import React from 'react'
import File from './File'
// { date: "2024-01-05", time: "16:03", status: "已审核", title: "审核通过", person: "王五" },

const Node = props => {
	const { log: { date, time, status, title, person, files }, prev, prev: { date: prevDate, status: prevStatus } = {}, first, last } = props

	return <div className='t-node'>
		<div className={`status-line${first ? ' first' : last ? ' last' : ''}`} />
		<div className='status-icon-wrap'>
			<div className={`status-icon${first ? ' first' : ''}${status == prevStatus ? '' : ' big'}`} />
		</div>
		<div className='date'>{date == prevDate ? '' : date}</div>
		<div className='time'>{time}</div>
		<div className='detail'>
			<div className='txt'>
				{status == prevStatus ? null : <div className='stress-txt'><b>{status}</b></div>}
				<span className='title'>{title}</span>(<span className='person'>{person}</span>)
			</div>
			{files?.length
				? <div className='files'>
					{files.map((file, index) => <File key={index} file={file} />)}
				</div>
				: null
			}
		</div>
	</div>
}

export default Node